import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'store-collection-view-purchases',
  templateUrl: './store-collection-view-purchases.component.html',
})
export class StoreCollectionViewPurchasesComponent implements OnInit {
  id: any = this.route.parent.snapshot.params.id;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
  }

}
